<form class="card mb-5">
  <div class="container section-container" [formGroup]="user_form">
    @if (can_delete_user()) {
      <div class="row">
        <div class="col-12">
          <button mat-flat-button color="warn" type="button" (click)="delete_user()">
            <mat-icon>delete</mat-icon>
            Eliminar
          </button>
        </div>
      </div>
    }
    <div class="row">
      <div class="col-12 col-md-6 col-xl-3">
        <mat-form-field class="nobottom" appearance="outline">
          <mat-label>Nombre</mat-label>
          <input type="text" matInput formControlName="name" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6 col-xl-3">
        <mat-form-field class="nobottom" appearance="outline">
          <mat-label>Apellidos</mat-label>
          <input type="text" matInput formControlName="surnames" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6 col-xl-3">
        <mat-form-field class="nobottom" appearance="outline">
          <mat-label>Correo electrónico</mat-label>
          <input type="email" matInput formControlName="email" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6 col-xl-3">
        <mat-form-field class="nobottom" appearance="outline">
          <mat-label>GitHub Username</mat-label>
          <input type="text" matInput formControlName="github_username" (blur)="update_github_username_error_state()" />
          <mat-hint>Obligatorio para workers y developers</mat-hint>
          @if (github_username_has_required_error()) {
            <mat-error>El campo GitHub Username es obligatorio</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6 col-xl-3">
        <button
          mat-stroked-button
          type="button"
          (click)="change_password()"
          [class.password-button]="its_me()"
          [disabled]="password_button_disabled()"
        >
          <mat-icon>lock</mat-icon>
          {{ password_button_label() }}
        </button>
      </div>
      <div class="col-12 col-md-6 col-xl-3">
        <mat-form-field class="nobottom" appearance="outline">
          <mat-label>Sexo</mat-label>
          <mat-select formControlName="sex">
            <mat-option value="M">Masculino</mat-option>
            <mat-option value="F">Femenino</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6 col-xl-3">
        <mat-form-field class="nobottom" appearance="outline">
          <mat-label>Fecha de nacimiento</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="birthday" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6 col-xl-3">
        <mat-form-field class="nobottom" appearance="outline">
          <mat-label>Teléfono móvil</mat-label>
          <input type="tel" matInput placeholder="+34.666 555 444" formControlName="phone" />
          <mat-icon matSuffix>phone</mat-icon>
          <mat-hint>F: +XX.XXX XXX XXX</mat-hint>
        </mat-form-field>
      </div>
    </div>

    @if (can_manage_roles()) {
      <div class="row">
        <h2>Rol</h2>
        <div class="col-12 col-md-6 col-lg-6">
          <mat-form-field class="nobottom" appearance="outline">
            <mat-label>Rol</mat-label>
            <mat-select formControlName="role_id">
              @for (role of roles(); track role) {
                <mat-option [value]="role.id">{{ role.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        @if (is_client_or_partner_role()) {
          <div class="col-12 col-md-6 col-lg-6">
            <mat-form-field class="nobottom" appearance="outline">
              <mat-label>{{ company_label() }}</mat-label>
              <input
                type="text"
                matInput
                [formControl]="client_select_control"
                [matAutocomplete]="clientSelectAuto"
                [disabled]="client_select_disabled()"
              />
              <mat-autocomplete #clientSelectAuto="matAutocomplete" [displayWith]="display_company">
                @for (company of available_customers(); track company) {
                  <mat-option [value]="company" (click)="select_customer(company)">{{ company.fact_name }}</mat-option>
                }
              </mat-autocomplete>
              @if (show_customer_reset()) {
                <button
                  mat-icon-button
                  class="field"
                  matSuffix
                  type="button"
                  aria-label="Limpiar empresa"
                  (click)="reset_customer()"
                  [disabled]="client_select_disabled()"
                >
                  <mat-icon>close</mat-icon>
                </button>
              } @else {
                <mat-icon matSuffix>expand_more</mat-icon>
              }
            </mat-form-field>
          </div>
        }
      </div>
    }

    <button class="mb-4" mat-flat-button color="accent" type="button" (click)="save_user()" [disabled]="save_user_disabled()">
      <mat-icon>save</mat-icon>
      Guardar
    </button>
  </div>
</form>

@if (show_company_form()) {
  <div class="company-data">
    <div class="page-title">
      <h1>Datos de empresa</h1>
    </div>
    <form class="card" [formGroup]="company_form">
      <div class="container section-container">
        <div class="row">
          <div class="col-12 col-md-6 col-xl-3">
            <mat-form-field class="nobottom" appearance="outline">
              <mat-label>Nombre</mat-label>
              <input type="text" matInput formControlName="fact_name" />
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6 col-xl-3">
            <mat-form-field class="nobottom" appearance="outline">
              <mat-label>Email de contacto</mat-label>
              <input type="text" matInput formControlName="email" />
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6 col-xl-3">
            <mat-form-field class="nobottom" appearance="outline">
              <mat-label>Teléfono de contacto</mat-label>
              <input type="text" matInput formControlName="phone" />
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6 col-xl-3">
            <mat-form-field class="nobottom" appearance="outline">
              <mat-label>NIF/CIF</mat-label>
              <input type="text" matInput formControlName="vat" />
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6 col-xl-6">
            <mat-form-field class="nobottom" appearance="outline">
              <mat-label>Dirección de facturación</mat-label>
              <input type="text" matInput formControlName="fact_address" />
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6 col-xl-3">
            <mat-form-field class="nobottom" appearance="outline">
              <mat-label>Ciudad</mat-label>
              <input type="text" matInput formControlName="fact_city" />
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6 col-xl-3">
            <mat-form-field class="nobottom" appearance="outline">
              <mat-label>Código postal</mat-label>
              <input type="text" matInput formControlName="fact_zipcode" />
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6 col-xl-3">
            <mat-form-field class="nobottom" appearance="outline">
              <mat-label>Provincia</mat-label>
              <input type="text" matInput formControlName="fact_county" />
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6 col-xl-3">
            <mat-form-field class="nobottom" appearance="outline">
              <mat-label>País</mat-label>
              <mat-select formControlName="fact_country">
                @for (country of countries; track country) {
                  <mat-option [value]="country.name">{{ country.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <button mat-flat-button color="accent" class="mb-1" type="button" (click)="save_company()" [disabled]="save_company_disabled()">
          <mat-icon>save</mat-icon>
          Guardar
        </button>
      </div>
    </form>
  </div>
}
